import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const MeetingsStartJoinIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="3.5"
      y="7"
      width="11"
      height="10"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.75"
    />
    <path
      d="M14.5 10.5L19.5 7.5V16.5L14.5 13.5"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
    <path
      d="M7 3.5C8.2 2.8 9.8 2.8 11 3.5"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <path
      d="M7 20.5C8.2 21.2 9.8 21.2 11 20.5"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </Icon>
);
